import { render } from "./G01ItemListGroupHeader.vue?vue&type=template&id=024c2dc8&scoped=true&ts=true"
import script from "./G01ItemListGroupHeader.vue?vue&type=script&lang=ts"
export * from "./G01ItemListGroupHeader.vue?vue&type=script&lang=ts"

import "./G01ItemListGroupHeader.vue?vue&type=style&index=0&id=024c2dc8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024c2dc8"]])

export default __exports__